import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

interface FaqItem {
  id: number;
  question: string;
  answer: string;
  isOpen: boolean;
}

@Component({
  selector: 'loyaltic-support-faq',
  templateUrl: './support-faq.component.html',
  styleUrls: ['./support-faq.component.scss']
})
export class SupportFaqComponent implements OnInit, OnDestroy {
  faqItems: FaqItem[] = [];
  intro = '';
  private translationSubscription: Subscription;

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    const keys = this.buildTranslationKeys();

    this.translationSubscription = this.translate.stream(keys).subscribe((translations: any) => {
      this.intro = this.getTranslatedValue(translations, 'faq-intro');
      this.faqItems = this.buildFaqItems(translations);
    });
  }

  ngOnDestroy() {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }

  toggleItem(item: FaqItem) {
    const shouldOpen = !item.isOpen;

    this.faqItems.forEach((faqItem: FaqItem) => {
      faqItem.isOpen = false;
    });

    item.isOpen = shouldOpen;
  }

  private buildTranslationKeys(): string[] {
    const keys = ['faq-title', 'faq-intro'];

    for (let i = 1; i <= 20; i++) {
      keys.push('faq-question-' + i);
      keys.push('faq-answer-' + i);
    }

    return keys;
  }

  private buildFaqItems(translations: any): FaqItem[] {
    const items: FaqItem[] = [];

    for (let i = 1; i <= 20; i++) {
      const question = this.getTranslatedValue(translations, 'faq-question-' + i);
      const answer = this.getTranslatedValue(translations, 'faq-answer-' + i);

      if (question && answer) {
        items.push({
          id: i,
          question: question,
          answer: answer,
          isOpen: false
        });
      }
    }

    return items;
  }

  private getTranslatedValue(translations: any, key: string): string {
    if (!translations || typeof translations[key] !== 'string') {
      return '';
    }

    const value = translations[key].trim();
    const textValue = value
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, '')
      .trim();
    const missingTranslationMarker = String.fromCharCode(9998);
    const isMissingTranslation = textValue.indexOf(key) > -1 && textValue.indexOf(missingTranslationMarker) > -1;

    if (!textValue || textValue === key || isMissingTranslation) {
      return '';
    }

    return value;
  }
}
